import { createLazyResolver } from 'owa-lazy-resolver';

export const lazyAppBarControlLockedTilesQueryWeb = createLazyResolver(
    'APPBARCONTROL_LOCKEDTILES_QUERY_WEB',
    () => import(/* webpackChunkName: "AppBarControlQueryWeb" */ './appBarControlQueryWeb'),
    m => m.appBarControlLockedTilesQueryWeb
);

export const lazyAppBarControlPinnedTilesQueryWeb = createLazyResolver(
    'APPBARCONTROL_PINNEDTILES_QUERY_WEB',
    () => import(/* webpackChunkName: "AppBarControlQueryWeb" */ './appBarControlQueryWeb'),
    m => m.appBarControlPinnedTilesQueryWeb
);

export const lazyAppBarControlMostRecentlyUsedTilesQueryWeb = createLazyResolver(
    'APPBARCONTROL_MOSTRECENTLYUSEDTILES_QUERY_WEB',
    () => import(/* webpackChunkName: "AppBarControlQueryWeb" */ './appBarControlQueryWeb'),
    m => m.appBarControlMostRecentlyUsedTilesQueryWeb
);
